import { colors } from "@mui/material";
import shadows from "./shadows";
import typography from "./typography";

const theme = {
  palette: {
    background: {
      // default: "#F4F6F8",
      paper: colors.common.white,
    },
    primary: {
      contrastText: "#ffffff",
      main: "#01588C",
    },
    secondary: {
      contrastText: "#ffffff",
      main: "#FC9E16",
    },
    main: {
      contrastText: "#ffffff",
      main: "#01588C",
      dark: "#054c75",
    },
    map: {
      main: "#FFFFFF",
      contrastText: "#333333"
    },
    orange: {
      contrastText: "#ffffff",
      main: "#FC9E16",
    },
    green: {
      contrastText: "#ffffff",
      main: "#4CAF50",
    },
    red: {
      contrastText: "#ffffff",
      main: "#FA0606",
    },
    text: {
      dark: "#172b4d",
      light: "#6b778c",
      lighter: "#878787",
      // orange: "#FC9E16",
      orange: "#FAB707",
      white: "#ffffff",
      placeholder: "#C7C7C7",
      title: "#6E6E6E",
      danger: "#cf160c",
      success: "#28a745",
      mainstyle: "#01588C"
    },
    navItem: {
      bgActive: "#E2E2E2",
    },
    danger: {
      contrastText: "#ffffff",
      main: "#cf160c",
    },
    white: {
      main: '#FFFFFF'
    },
    yellow: {
      contrastText: "#1E1E1E",
      main: "#FFBA21",
    },
    blue: {
      main: "#0047AB"
    },
    landing: {
      background: {
        light: "#ffffff",
        dark: "#eff1f6"
      },
      brandBlue: '#01588C',
      brandOrange: '#FC9E16'
    }
  },
  shadows,
  typography: {
    ...typography,
    fontFamily: "IBM Plex Sans Arabic, Dubai, AraHamah1964, Arial",
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          textAlign: "start",
          fontSize: 18,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 18,
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: "#01588C"
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        action: {
          alignSelf: 'center',
        },
      },
    },
    'MuiDataGrid': {
      styleOverrides: {
        cell: {
          columnHeaderCheckbox: {
            color: '#01588C'
          }
        }
      }
    }
  },
};
export default theme;
